// Types
import { IconNameToIconID } from '../components/Spritesheet/types/IconNameToIconIdMap';
export var doesIconExistOnSpritesheet = function (iconName) {
    return iconName in IconNameToIconID;
};
//# sourceMappingURL=doesIconExistOnSpritesheet.js.map